import { createSelector } from 'reselect';
import MrdMonitoringReportsColumns from '../../../component/MrdMonitoringReportsColumns';
import TableDefinitions from '../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.MRD_MONITORING_REPORT_REPORTED_BY_USER.isLoading;
export const getData = TableDefinitions.MRD_MONITORING_REPORT_REPORTED_BY_USER.getDataFunction();
export const getColumns = createSelector(getData, MrdMonitoringReportsColumns);
